import { CheckCircleOutlineIcon, CircleCloseIcon } from '@src/svg';
import { createSlice } from '@reduxjs/toolkit';
import { serviceApi } from '@store/rtk/service';
import { TableData } from '@uikit/Tables/types';
import { beautifyDateTime } from '@src/utils';
import { TABLE_COLUMNS } from '@uikit/Tables/columns';

type PayorsServicesSliceType = {
  serviceTransportData: {
    effectiveDate: string;
    executionDate: string;
    expirationDate: string;
    payor_id: number;
    loadDuration: string;
    unloadDuration: string;
    type_id: number;
  } | null;
  serviceType: {
    category: number;
    business: number;
    type_id: number;
    effectiveDate: string;
    payor_id: number;
    expirationDate: string;
    approvedService: boolean;
  } | null;
  servicesData: TableData;
};

const { payerServicesColumns } = TABLE_COLUMNS;

const initialState: PayorsServicesSliceType = {
  serviceTransportData: null,
  serviceType: null,
  servicesData: {
    columns: payerServicesColumns,
    rows: [],
    size: 10,
  },
};

export const payorsServicesSlice = createSlice({
  name: 'payorsServices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      serviceApi.endpoints.getService.matchFulfilled,
      (state, { payload }) => {
        state.servicesData = {
          ...state.servicesData,
          rows: [
            ...payload.content.map((el, idx) => ({
              ...el,
              id: el.id ? el.id : idx,
              effectiveDate: beautifyDateTime(el?.effectiveDate),
              expirationDate: beautifyDateTime(el?.expirationDate),
              approvedService: Boolean(el?.approvedService) ? (
                <span className="rendering-service-covered-icon is-covered">
                  <CheckCircleOutlineIcon width={16} height={16} />
                </span>
              ) : (
                <span className="rendering-service-covered-icon is-uncovered">
                  <CircleCloseIcon width={16} height={16} />
                </span>
              ),
            })),
          ],
          ...payload,
          requestTablePageChange: serviceApi.endpoints.getService,
          filter: payload.filter || {},
        };
      }
    );
  },
});

export const selectPayorsServices = (state: {
  payorsServices: PayorsServicesSliceType;
}) => state.payorsServices;
export const payorsServiceReducer = payorsServicesSlice.reducer;
